module.exports = __webpack_public_path__ + "img/星链鞋履供应链解决方案水印.89f5097b.png";